import { render, staticRenderFns } from "./AssignPositionID.vue?vue&type=template&id=e524ad62&"
import script from "./AssignPositionID.vue?vue&type=script&lang=js&"
export * from "./AssignPositionID.vue?vue&type=script&lang=js&"
import style0 from "./AssignPositionID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports